import {ShippingInstructionTableRow} from '../../article/models/article-extra.models';
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'delivery-condition-ou-table',
    templateUrl: './delivery-condition-ou-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeliveryConditionOuTableComponent {
  @Input() tableName: string;
  @Input() deliveryConditionList: ShippingInstructionTableRow[] = [];

  constructor() {
  }
}
